<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
    <g class="a" transform="translate(1 1)">
      <circle class="b" cx="5.5" cy="5.5" r="5.5"/>
      <circle class="c" cx="5.5" cy="5.5" r="6"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EllipseIcon'
}
</script>

<style scoped>
.a {
  fill: #b833cc;
  stroke: #fff;
}

.b {
  stroke: none;
}

.c {
  fill: none;
}
</style>
